var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useEffect, useState } from 'react';
export default function StripStickyTabs(props) {
    var fields = props.fields, children = props.children;
    var TitleTag = (fields.titleTag || 'h1');
    var _a = useState([]), slideProgresses = _a[0], setSlideProgresses = _a[1];
    var slideRefs = useRef([]);
    useEffect(function () {
        setSlideProgresses(new Array(children.length).fill(0));
        var handleScroll = function () {
            var newSlideProgresses = slideRefs.current.map(function (slide, index) {
                if (slide) {
                    var offsetTop = slide.offsetTop, offsetHeight = slide.offsetHeight;
                    var scrollPosition = window.scrollY + window.innerHeight / 2;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        var progress = (scrollPosition - offsetTop) / offsetHeight;
                        return Math.min(Math.max(progress, 0), 1);
                    }
                    else if (scrollPosition < offsetTop) {
                        return 0;
                    }
                    else {
                        return 1;
                    }
                }
                return 0;
            });
            setSlideProgresses(newSlideProgresses);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [children]);
    return (React.createElement("div", __assign({ className: "strip sky23-sticky-tabs text-white spa-sticky-tabs "
            + fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col' },
                    React.createElement(StickyHeader, { slides: children.map(function (child, index) { return ({
                            slideNumber: index + 1,
                            title: child.fields.title || '',
                            progress: slideProgresses[index] || 0
                        }); }) }),
                    React.createElement("div", { className: "".concat(fields.textColor, " sticky-tabs-heading") },
                        fields.preTitle && React.createElement("h3", null, fields.preTitle),
                        fields.displayTitle && React.createElement(TitleTag, null, fields.displayTitle)),
                    children && children.length > 0 && children.map(function (child, index) {
                        var childFields = child.fields;
                        var slideIndex = index + 1;
                        var slideNumber = slideIndex < 10 ? "0".concat(slideIndex) : "".concat(slideIndex);
                        var ContentTitleTag = childFields.contentTitleTag || 'h3';
                        return (React.createElement("div", { key: index, className: "sticky-tab-item", ref: function (el) { return (slideRefs.current[index] = el); } },
                            React.createElement("div", { className: "row align-items-start mb-4" },
                                React.createElement("div", { className: "col-12 col-xl-4" },
                                    React.createElement("div", { className: "h2" }, childFields.title)),
                                React.createElement("div", { className: "col-12 col-xl-8 ".concat(fields.detailColor) },
                                    childFields.contentTitle &&
                                        React.createElement(ContentTitleTag, null, childFields.contentTitle),
                                    childFields.contentDescription && (React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-lg-6 col-12" },
                                            React.createElement("div", { className: "description" }, childFields.contentDescription)))))),
                            childFields.largeImage ? (React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col" },
                                    React.createElement("img", { src: childFields.largeImage, title: childFields.largeImage_title || 'Large Image', alt: childFields.largeImage_description || 'Large Image', className: "img-fluid" })))) : childFields.smallImage && childFields.mediumImage ? (React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12 col-xl-4 mb-3 mb-xl-0" },
                                    React.createElement("img", { src: childFields.smallImage, title: childFields.smallImage_title || 'Small Image', alt: childFields.smallImage_description || 'Small Image', className: "img-fluid h-auto" })),
                                React.createElement("div", { className: "col-12 col-xl-8" },
                                    React.createElement("img", { src: childFields.mediumImage, title: childFields.mediumImage_title || 'Medium Image', alt: childFields.mediumImage_description || 'Medium Image', className: "img-fluid" })))) : childFields.mediumImage ? (React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12 col-xl-4" }),
                                React.createElement("div", { className: "col-12 col-xl-8" },
                                    React.createElement("img", { src: childFields.mediumImage, title: childFields.mediumImage_title || 'Medium Image', alt: childFields.mediumImage_description || 'Medium Image', className: "img-fluid" })))) : childFields.smallImage ? (React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12 col-xl-4" },
                                    React.createElement("img", { src: childFields.smallImage, title: childFields.smallImage_title || 'Small Image', alt: childFields.smallImage_description || 'Small Image', className: "img-fluid h-auto" })),
                                React.createElement("div", { className: "col-12 col-xl-8" }))) : null));
                    }))))));
}
function StickyHeader(_a) {
    var slides = _a.slides;
    var _b = useState(false), isSticky = _b[0], setIsSticky = _b[1];
    var headerRef = useRef(null);
    var isInViewport = function (element) {
        if (!element)
            return false;
        var rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= window.innerHeight;
    };
    useEffect(function () {
        var handleScroll = function () {
            var anySlideInProgress = slides.some(function (e) { return e.progress > 0; });
            var headerInView = isInViewport(headerRef.current);
            setIsSticky(anySlideInProgress && headerInView);
        };
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, [slides]);
    return (React.createElement("div", { ref: headerRef, className: "sticky-header d-flex w-100 flex-nowrap ".concat(isSticky ? 'sticky' : '') }, slides.map(function (slide, index) {
        var formattedSlideNumber = slide.slideNumber < 10 ? "0".concat(slide.slideNumber) : "".concat(slide.slideNumber);
        var progress = slide.progress || 0;
        var title = slide.title || '';
        var isActive = progress > 0;
        return (React.createElement("div", { key: index, className: "slide-info ".concat(isActive ? 'active' : '', " flex-grow-1") },
            React.createElement("div", { className: "progress-bar-container" },
                React.createElement("div", { className: "progress-bar", style: { width: "".concat(progress * 100, "%") } })),
            React.createElement("div", { className: "slide-number" }, formattedSlideNumber),
            React.createElement("div", { className: "slide-title" }, title)));
    })));
}
